<modal #modal>
  <div class="col-12 container">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
      &times;
    </button>
    <h1 class="header">Din kurv er udløbet</h1>
    <p>Vi kan konstatere, at der ikke har været aktivitet på denne side i lang tid. Grundet dette, er det
      indhold, du havde i din kurv blevet slettet og frigivet igen.</p>
    <p class="spacer">Oplever du problemer, så kontakt Kundeservice via vores chat,
      <a class="link" href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> eller telefon: <a class="link"
        href="tel:+4533420900">3342
        0900</a>
    </p>
    <app-opening-hours></app-opening-hours>
  </div>
</modal>
